import { deepmerge } from 'deepmerge-ts'

export const merge = deepmerge
